import React, {
  SyntheticEvent,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Gantt, Task as GanntTask, ViewMode } from "./gantt/src";
import { QueryObserverResult, RefetchOptions } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";
import { TaskResponse } from "@/api/query/useAllTaskQuery";
import { ErrorResponseType } from "@/api/types/axiosResponseType";
import UserAvatar from "@/components/ui/userAvatar";
import Dialog from "@/components/common/Dialog";
import ProjectStatusEditBlockedDialog from "@/components/project/ProjectStatusEditBlockedDialog";
import { Task as ApiTask, Task } from "@/api/mutation/useTaskCreateMutation";
import useUpdateTaskMutation from "@/api/mutation/useTaskUpdateMutation";
import { useUser } from "@/hooks/useUser";
import { OrgListOfNonWorkingDaysEnum } from "@backend/src/schemas/organisationSchema";
import { errorKeyFormate } from "@/helperFuntions/errroMessage";
import { downloadGanttAsPdf } from "@/helperFuntions/downloadGanttAsPdf";
import useProjectQuery from "@/api/query/useProjectQuery";
import { Button } from "@/components/ui/button";
import { errorConfig } from "@/lib/toastError";
import { toast } from "react-toastify";
import {
  TaskDependenciesEnumValue,
  TaskStatusEnumValue,
  UserRoleEnumValue,
  StatusEnumSchema,
  ProjectStatusEnumValue,
} from "@backend/src/schemas/enums";
import useRemoveTaskDependenciesMutation from "@/api/mutation/useTaskRemoveDependencies";
import { useTranslation } from "react-i18next";
import TrashCan from "@/assets/svg/TrashCan.svg";
import { darkenColor } from "./gantt/src/helpers/colorMixer";
import useTaskDependenciesMutation from "@/api/mutation/useTaskDependenciesmutaion";
import TaskSubTaskForm from "@/components/tasks/taskSubTaskForm";
import { useParams, useNavigate } from "react-router-dom";
import useProjectDetail, {
  ProjectDetailType,
} from "@/api/query/useProjectDetailQuery";
import useRemoveTaskMutation from "@/api/mutation/useTaskRemove";
import RedFlag from "@/assets/svg/RedFlag.svg";
import OrangeFlag from "@/assets/svg/OrangeFlag.svg";
import GreenFlag from "@/assets/svg/GreenFlag.svg";
import PercentageCircle from "@/components/shared/PercentageCircle";
import { CustomGanttContextMenuContentForProjectTaskView } from "./gantt/src/components/other/customGanttContextMenuForProjectTaskView";
import YallowInfoIcon from "@/assets/svg/YallowInfoIcon.svg";
import { calculateTaskEffort } from "@/hooks/useEffortCalculation";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { UserType } from "@/api/query/useCurrentUserQuery";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import InputText from "@/components/common/InputText";
import { CheckIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import InfoCircle from "@/assets/svg/Info circle.svg";
import Extermination from "@/assets/v2/svg/Extermination.svg";
import BlueAttachment from "@/assets/v2/svg/BlueAttachment.svg";
import Note from "@/assets/v2/svg/Note.svg";
import { useGetCapacityPlanningMutation } from "@/api/mutation/useGetCapacityPlanningMutation";
import {
  canManageProjectTasksAndContent,
  normalizeProjectScope,
} from "@/utils/projectRoleAccess";

export type GanttTaskExtendedType = GanntTask & {
  subtask?: GanttTaskExtendedType[];
  duration: number;
  assign: any[];
  level: string;
  status: string;
  flag: string;
  plannedProgression: number;
};
export default function Custom(props: {
  data: ApiTask[];
  refetch: (
    options?: RefetchOptions,
  ) => Promise<
    QueryObserverResult<
      AxiosResponse<TaskResponse, unknown>,
      AxiosError<ErrorResponseType, unknown>
    >
  >;
  // snap: boolean;
  FilterUnit: number;
  setFilterUnit: (data: number) => void;
  expandAll: boolean;
  popUpClose: boolean;
  isRefetching: boolean;
  IsOpenWorkLoad: boolean;
  selectedTaskId: string;
  handleDownloadGanttPdfComplete?: () => void;
  ganttPdfRef?: React.MutableRefObject<{
    handleDownloadGanttPdf: () => void;
  } | null>;
  bulkSelectedTaskIds?: string[];
  onBulkSelectedTaskIdsChange?: (taskIds: string[]) => void;
  bulkSelectionSourceTasks?: ApiTask[];
  // zoomLevel:number;
}) {
  const { user } = useUser();
  const nonWorkingDays = () => {
    const nWd =
      user?.userOrganisation.map((org) => org.organisation.nonWorkingDays) ||
      [];
    const mapDayToNumber = (day: OrgListOfNonWorkingDaysEnum) => {
      switch (day) {
        case "SUN":
          return 0;
        case "MON":
          return 1;
        case "TUE":
          return 2;
        case "WED":
          return 3;
        case "THU":
          return 4;
        case "FRI":
          return 5;
        case "SAT":
          return 6;
        default:
          return 0;
      }
    };
    const result: number[] = [];
    nWd.forEach((days) => {
      days.forEach((day) => {
        result.push(mapDayToNumber(day));
      });
    });
    return result;
  };
  const [convertedData, setConvertedData] = useState<GanttTaskExtendedType[]>();
  // const [projects, setProjects] = useState<Project[]>([]);

  const [taskSorted, setTaskSorted] = useState<any>();
  const [createSub, setCreateSub] = useState<string>();
  const [expanded, setExpanded] = useState<string[]>();
  const { t } = useTranslation();
  const { projectId } = useParams();
  const navigate = useNavigate();
  const projectDetailQuery = useProjectDetail(projectId, true);
  const [project, setProject] = useState<ProjectDetailType>();
  const [endDate, setEndDate] = useState<Date>(new Date());
  const [taskSlice, setTaskSlice] = useState<number>(0);
  const projectQuery = useProjectQuery();
  const tasksPerPage = 30;
  const tasksIncrement = 10;
  const getParentTasks = (tasks: ApiTask[]) => {
    // Step 1: Filter tasks that do not have a parentTaskId (considered parent tasks)
    let parentTasks = tasks.filter((task) => !task.parentTaskId);

    // Step 2: If no parent tasks are found, treat tasks that only appear as subtasks as independent tasks
    if (parentTasks.length === 0) {
      const subtaskIds = new Set(
        tasks.flatMap((task) => task.subtasks?.map((sub) => sub.taskId) || []),
      );

      parentTasks = tasks.filter((task) => !subtaskIds.has(task.taskId));
    }

    // Step 3: Sort the identified parent tasks by their start date
    return parentTasks.sort(
      (a, b) =>
        new Date(a.startDate).getTime() - new Date(b.startDate).getTime(),
    );
  };

  const getTasksWithSubtasks = (
    tasks: ApiTask[],
    start: number,
    end: number,
  ) => {
    const parentTasks = getParentTasks(tasks);
    const totalParentTasks = parentTasks.length;

    // Handle pagination
    const startIndex = Math.min(
      start,
      Math.max(0, totalParentTasks - tasksPerPage),
    );
    const endIndex = Math.min(end, totalParentTasks);

    // Paginate the parent tasks
    const paginatedParentTasks = parentTasks.slice(startIndex, endIndex);

    const result: ApiTask[] = [];

    // Recursive function to add tasks and their subtasks
    const addTaskWithSubtasks = (task: ApiTask) => {
      result.push(task);
      if (task.subtasks) {
        task.subtasks.forEach((subtask) => {
          const foundTask = tasks.find((t) => t.taskId === subtask.taskId);
          if (foundTask) {
            addTaskWithSubtasks(foundTask);
          }
        });
      }
    };

    // Add the paginated parent tasks and their subtasks
    paginatedParentTasks.forEach(addTaskWithSubtasks);

    return result;
  };
  const [isProject, setIsProject] = useState(false);
  useEffect(() => {
    if (!projectDetailQuery.data?.data.data) return;
    const project = projectDetailQuery.data.data.data;
    setProject({ ...project });
  }, [projectDetailQuery.data?.data.data, isProject]);

  const projectStatus = projectDetailQuery.data?.data.data.status;
  const isProjectEditBlocked =
    projectStatus === ProjectStatusEnumValue.CANCELLED ||
    projectStatus === ProjectStatusEnumValue.ON_HOLD ||
    projectStatus === ProjectStatusEnumValue.COMPLETED ||
    projectStatus === ProjectStatusEnumValue.CLOSED;

  const [isProjectEditBlockedDialogOpen, setIsProjectEditBlockedDialogOpen] = useState(false)
  const [view, setView] = useState(ViewMode.Day);
  const [inPercentage, setinPercentage] = useState(true);

  const projectDetailRef = useRef<any>();
  projectDetailRef.current = projectDetailQuery.data?.data?.data;

  const { mutate, isPending } = useGetCapacityPlanningMutation();
  const fetchData = useCallback(() => {
    const payload = {
      viewMode: view,
      inPercentage: inPercentage,
      isWorkloadPlanning: true,
      dates: [], // or pass actual dates if needed
      limit: 500,
    };
    mutate(payload as any, {
      onSuccess: (res: any) => {
        const assignedUsers = projectDetailRef.current?.assignedUsers || [];
        setTaskSorted({
          resources: (res.data.data?.resource?.resources || []).filter((u: any) =>
            assignedUsers.some((t: any) => t.user?.userId === u.id)
          ),
          dailyWorkload: res.data.data?.resource?.dailyWorkload || {},
        });
      },

      onError: () => { },
    });
  }, [view, inPercentage, mutate]);
  const sortAndFlattenTask = (
    tasks: GanttTaskExtendedType[],
    hidden: boolean,
  ): GanttTaskExtendedType[] => {
    const sortedData: GanttTaskExtendedType[] = [];
    const taskMap = new Map<string, GanttTaskExtendedType>();

    // First pass: create a map of all tasks
    const mapTasks = (task: GanttTaskExtendedType) => {
      taskMap.set(task.id, task);
      if (task.subtask) {
        task.subtask.forEach(mapTasks);
      }
    };
    tasks.forEach(mapTasks);

    const flattenTasks = (task: GanttTaskExtendedType, level: string) => {
      sortedData.push({ ...task, level });
      if (hidden) {
        if (task.subtask && !task.hideChildren) {
          task.subtask
            .sort(
              (a, b) =>
                new Date(a.start ?? new Date()).getTime() -
                new Date(b.start ?? new Date()).getTime(),
            )
            .forEach((subtask, index) => {
              const subLevel = `${level}.${index + 1}`;
              if (taskMap.has(subtask.id)) {
                flattenTasks(taskMap.get(subtask.id)!, subLevel);
              }
            });
        }
      } else {
        if (task.subtask) {
          task.subtask
            .sort(
              (a, b) =>
                new Date(a.start ?? new Date()).getTime() -
                new Date(b.start ?? new Date()).getTime(),
            )
            .forEach((subtask, index) => {
              const subLevel = `${level}.${index + 1}`;
              if (taskMap.has(subtask.id)) {
                flattenTasks(taskMap.get(subtask.id)!, subLevel);
              }
            });
        }
      }
    };

    // Second pass: flatten the tasks
    tasks
      .filter((t) =>
        tasks.some((t) => t.id === t.project) ? !t.project : true,
      )
      .sort(
        (a, b) =>
          new Date(a.start ?? new Date()).getTime() -
          new Date(b.start ?? new Date()).getTime(),
      )
      .forEach((task, index) => {
        const level = `${index + 1}`;
        flattenTasks(task, level);
      });

    return sortedData;
  };

  // const convertedTasks = useMemo(
  //   () => convertProject(projectQuery.data?.data.data ?? []),
  //   [projectQuery.data?.data.data, expanded]
  // );
  useEffect(() => {
    if (props.IsOpenWorkLoad) {
      fetchData();
    }
  }, [view, inPercentage, props.IsOpenWorkLoad]);

  useEffect(() => {
    function findLastDate(tasks: Task[]) {
      if (!tasks || tasks?.length === 0) {
        return new Date();
      }
      const dateEndTimestamps = props.data.map((task) =>
        new Date(task.endDate).getTime(),
      );
      const lastTimestamp = Math.max(...dateEndTimestamps);
      const lastDate = new Date(lastTimestamp);
      lastDate.setHours(23, 59, 0, 0);
      lastDate.setDate(lastDate.getDate() + 1);
      if (endDate !== lastDate) {
        setEndDate(lastDate);
      }
    }
    findLastDate(props.data);
  }, [props.data, projectId]);

  useEffect(() => {
    const tempV: string[] = expanded ? [...expanded] : [];
    const getParantTaskId = (task: Task[]) => {
      if (props.expandAll) {
        task.forEach((element) => {
          if (element.subtasks?.length) {
            if (!tempV.includes(element.taskId)) {
              tempV.push(element.taskId);
            }
            getParantTaskId(element.subtasks);
          } else if (!element.parentTaskId) {
            if (!tempV.includes(element.taskId)) {
              tempV.push(element.taskId);
            }
          }
        });
      } else {
        tempV.length = 0;
      }
    };

    getParantTaskId(props.data);

    if (JSON.stringify(expanded) !== JSON.stringify(tempV)) {
      setExpanded([...tempV]); // Always create a new array
    }
  }, [props.expandAll, projectId, props.data]);
  const [newTask, setNewTask] = useState<GanttTaskExtendedType>();
  useEffect(() => {
    setData();
  }, [props.data, taskSlice, expanded]);
  const [resourcesTask, setresourcesTask] = useState<GanttTaskExtendedType[]>(
    [],
  );
  const setData = () => {
    if (props.data) {
      // Step 1: Retrieve tasks with their subtasks
      const allTasks = getTasksWithSubtasks(
        props.data,
        taskSlice,
        taskSlice + tasksPerPage,
      );

      // Step 2: Filter out non-parent tasks (if needed)
      const filteredTasks = allTasks.filter((task) =>
        allTasks.some((t) => t.taskId === task.parentTaskId)
          ? !task.parentTaskId
          : true,
      );

      // Step 3: Sort the filtered tasks by start date
      const sortedTasks = filteredTasks.sort(
        (a, b) =>
          new Date(a.startDate).getTime() - new Date(b.startDate).getTime(),
      );
      // Step 4: Flatten the sorted tasks

      // Step 5: Convert tasks at the final step
      const convertedTasks = sortedTasks.map((task) => convertTasks(task));

      const flattenedResourse = sortAndFlattenTask(convertedTasks, false);
      setresourcesTask(flattenedResourse);
      const flattenedTasks = sortAndFlattenTask(convertedTasks, true);
      // Step 6: Set the final data

      setConvertedData(flattenedTasks);
    }
  };

  const convertTasks = (originalTask: ApiTask): GanttTaskExtendedType => {
    const rawStart = originalTask?.startDate ? new Date(originalTask.startDate) : new Date();
    const startDate = !isNaN(rawStart.getTime()) ? rawStart : new Date();
    startDate.setHours(0, 0, 0, 0);

    const rawEnd = originalTask?.endDate ? new Date(originalTask.endDate) : new Date();
    const endDate = !isNaN(rawEnd.getTime()) ? rawEnd : new Date();
    endDate.setHours(23, 59, 0, 0);
    const dependencies = originalTask?.dependencies
      ? originalTask?.dependencies
        .filter(
          (e: ApiTask["dependencies"][0]) =>
            e.dependentType == "PREDECESSORS",
        )
        .map(
          (dep: { dependendentOnTaskId: string }) => dep.dependendentOnTaskId,
        )
        .filter((depId) => props.data?.some((task) => task.taskId === depId)) // Filter out non-existent dependencies
      : [];

    const subtask =
      originalTask?.subtasks && originalTask?.subtasks.length > 0
        ? originalTask?.subtasks
          .filter((s: ApiTask) => s && s.taskId)
          .sort(
            (
              a: { startDate: string | number | Date },
              b: { startDate: string | number | Date },
            ) => {
              const aTime = a?.startDate ? new Date(a.startDate).getTime() : 0;
              const bTime = b?.startDate ? new Date(b.startDate).getTime() : 0;
              return (isNaN(aTime) ? 0 : aTime) - (isNaN(bTime) ? 0 : bTime);
            },
          )
          .map((s: ApiTask) => {
            const foundTask = props.data?.find(
              (t: { taskId: string }) => t.taskId === s.taskId,
            );

            // Only convert if the task is found in props.data
            return foundTask ? convertTasks(foundTask as ApiTask) : null;
          })
          .filter((task): task is GanttTaskExtendedType => task !== null) // Filter out null values
        : [];
    const types = originalTask?.milestoneIndicator
      ? "milestone"
      : !subtask?.length
        ? "task"
        : "project";

    return {
      createdByUserId: originalTask.createdByUserId,
      id: originalTask.taskId,
      type: types,
      name: originalTask.taskName,
      start: startDate ?? new Date(),
      end: endDate ?? new Date(),
      progress: originalTask?.completionPecentage
        ? parseFloat(originalTask?.completionPecentage)
        : 0,
      plannedProgression: originalTask?.plannedProgression
        ? parseFloat(originalTask?.plannedProgression + '')
        : 0,
      project: originalTask.parentTaskId ?? "",
      dependencies,
      hideChildren: !expanded?.includes(originalTask?.taskId),
      subtask,
      assign: originalTask?.assignedUsers,
      duration: originalTask?.duration,
      level: "",
      status: originalTask.status,
      flag: originalTask.flag,
      isDisabled: !allowed(originalTask.projectId, originalTask),
      styles: {
        backgroundSelectedColor: originalTask?.ganttColor
          ? darkenColor(originalTask?.ganttColor, 0.2)
          : types === "project"
            ? darkenColor("#525DF9", 0.2)
            : types === "milestone"
              ? darkenColor("#fa7181", 0.2)
              : darkenColor("#22c55e", 0.2),
        progressSelectedColor: originalTask?.ganttColor
          ? darkenColor(originalTask?.ganttColor, 0.4)
          : types === "project"
            ? darkenColor("#525DF9", 0.4)
            : types === "milestone"
              ? darkenColor("#fa7181", 0.4)
              : darkenColor("#22c55e", 0.4),
        backgroundColor: originalTask?.ganttColor
          ? darkenColor(originalTask?.ganttColor, 0.1)
          : types === "project"
            ? darkenColor("#525DF9", 0.1)
            : types === "milestone"
              ? darkenColor("#fa7181", 0.1)
              : darkenColor("#22c55e", 0.1),
        progressColor: originalTask?.ganttColor
          ? darkenColor(originalTask?.ganttColor, 0.25)
          : types === "project"
            ? darkenColor("#525DF9", 0.25)
            : types === "milestone"
              ? darkenColor("#fa7181", 0.25)
              : darkenColor("#22c55e", 0.25),
      },
    };
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case TaskStatusEnumValue.NOT_STARTED:
        return "!bg-status-gray text-white";
      case TaskStatusEnumValue.IN_PROGRESS:
        return "!bg-status-blue text-white";
      case TaskStatusEnumValue.COMPLETED:
        return "!bg-status-green text-white";
    }
  };
  function dateFormater(inputDate: Date): string {
    const date = new Date(inputDate);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();

    return `${year}-${month.toString().padStart(2, "0")}-${day
      .toString()
      .padStart(2, "0")}`;
  }

  const [removeDepandancy, setRemoveDepandancy] = useState<any>();

  const removeDepandancyFn = () => {
    let temp: GanttTaskExtendedType[] = [];
    if (convertedData) {
      convertedData.forEach((e) => {
        if (e.id === removeDepandancy.to.id) {
          e.dependencies = e.dependencies?.filter(
            (t: string) => t !== removeDepandancy.from.id,
          );
        }
        temp.push(e);
      });
      setConvertedData(temp);
      temp = [];
    }
    setRemoveDepandancy(null);
  };

  const expandToggle = useCallback((id: string) => {
    setExpanded((prev) => {
      if (prev?.includes(id)) {
        return prev.filter((t) => t !== id);
      }
      return [...(prev ?? []), id];
    });
  }, []);
  const viewModes = useMemo(
    () => [
      ViewMode.Day,
      ViewMode.Week,
      ViewMode.Month,
      ViewMode.QuarterYear,
      ViewMode.Year,
    ],
    [],
  );
  const minZoom = 0;
  const maxZoom = viewModes.length - 1;

  const validUnit = Math.max(
    minZoom,
    Math.min(props.FilterUnit ?? 0, maxZoom),
  );

  useEffect(() => {
    setView(viewModes[validUnit]);
  }, [validUnit, viewModes]);

  const Divref = useRef<HTMLDivElement | null>(null);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [getError, setGetError] = useState<string>();
  const [taskNewDate, setTaskNewDate] = useState<Date>();

  useEffect(() => {
    let timeoutId: number;
    const handleScroll = (event: WheelEvent) => {
      if (event.ctrlKey) {
        event.preventDefault();
        clearTimeout(timeoutId);
        timeoutId = window.setTimeout(() => {
          if (event.deltaY < 0 && validUnit > minZoom) {
            props.setFilterUnit(validUnit - 1);
          } else if (event.deltaY > 0 && validUnit < maxZoom) {
            props.setFilterUnit(validUnit + 1);
          }
        }, 100);
      }
    };

    const div = Divref.current;
    if (div) {
      div.addEventListener("wheel", handleScroll);
    }

    return () => {
      if (div) {
        div.removeEventListener("wheel", handleScroll);
      }
    };
  }, [validUnit, props.setFilterUnit]);

  function calculateDurations(startDate: Date, endDate: Date) {
    const start = new Date(startDate);
    const end = new Date(endDate);

    // Initialize duration in days
    let duration = 0;

    const holidays =
      user?.userOrganisation[0].organisation.orgHolidays?.map((h) =>
        dateFormater(new Date(h.holidayStartDate)),
      ) ?? [];
    // Loop from start date to end date
    for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
      const day = d.getDay();
      const formattedDate = d.toISOString().split("T")[0];

      // Check if it's a non-working day (weekend) or a holiday
      if (
        !nonWorkingDays().includes(day) &&
        !holidays.includes(dateFormater(new Date(formattedDate)))
      ) {
        duration++;
      }
    }

    return duration;
  }

  const UTCDateConverter = (date: Date) => {
    return new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0),
    );
  };
  const [updatedBy, setUpdatedBy] = useState<{
    key: string;
    value: Date | number | string;
  }>();
  const taskUpdateMutation = useUpdateTaskMutation();

  const updateTaskFromGanttView = (event: GanttTaskExtendedType) => {
    if (isProjectEditBlocked) {
      setIsProjectEditBlockedDialogOpen(true);
      return;
    }
    if (event) {
      let data: any;
      const findTask = props.data?.find((t) => t.taskId == event.id);
      if (!findTask) {
        return;
      }
      const convertedTask = convertTasks(findTask);
      if (
        dateFormater(convertedTask?.start ?? new Date()) !==
        dateFormater(event.start)
      ) {
        // const startDate = new Date(event.start ?? "");
        // startDate.setUTCHours(0, 0, 0, 0);
        // startDate.setDate(startDate.getDate() + 1);
        data = {
          id: event.id,
          startDate: UTCDateConverter(event.start),
        };

        setUpdatedBy({ key: "taskdrop", value: UTCDateConverter(event.start) });
      } else if (
        dateFormater(convertedTask?.end ?? new Date()) !==
        dateFormater(event.end)
      ) {
        setUpdatedBy({
          key: "taskresizeend",
          value:
            Math.round(Math.abs(event.duration)) <= 0
              ? 1
              : Math.round(Math.abs(event.duration)),
        });
        data = {
          id: event.id,
          duration: calculateDurations(
            UTCDateConverter(event.start),
            UTCDateConverter(event.end),
          ),
        };
      }
      if (convertedTask?.progress !== event.progress) {
        setUpdatedBy({ key: "percentbardrop", value: event.progress });
        data = {
          id: event.id,
          completionPecentage: event.progress,
          kanbanColumnId: "",
        };
      }

      if (event && data?.id) {
        UpdateApiCall(data);
        setConvertedData(
          convertedData?.map((t) =>
            t.id === data?.id
              ? {
                ...t,
                start: event.start,
                end: event.end,
                progress: event.progress,
              }
              : t,
          ),
        );
      }
    }
  };
  const [editingCell, setEditingCell] = useState<{
    rowId: string;
    field: string;
  } | null>(null);
  const [editingValue, setEditingValue] = useState<string | number | Date>("");
  // const [, setUniqueUsers] = useState<any[]>([]);

  const handleBlur = (task: GanttTaskExtendedType) => {
    const updated: any = { id: task.id };
    if (editingCell && editingCell.field === "name")
      updated.taskName = editingValue;
    if (editingCell && editingCell.field === "duration")
      updated.duration = Number(editingValue);
    if (editingCell && editingCell.field === "start")
      updated.startDate = new Date(editingValue);
    if (editingCell && editingCell.field === "progress")
      updated.completionPecentage = Number(editingValue);
    if (editingCell && editingCell.field === "status") {
      updated.status = editingValue;
      if (editingValue == TaskStatusEnumValue.NOT_STARTED) {
        updated.completionPecentage = 0;
      } else if (editingValue == TaskStatusEnumValue.IN_PROGRESS) {
        updated.completionPecentage = 50;
      } else if (editingValue == TaskStatusEnumValue.COMPLETED) {
        updated.completionPecentage = 100;
      }
    }

    UpdateApiCall(updated);
    setEditingCell(null);
  };

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    task: GanttTaskExtendedType,
  ) => {
    if (e.key === "Enter") {
      handleBlur(task);
    }
  };
  const UpdateApiCall = (
    data: {
      taskName?: string | undefined;
      taskDescription?: string | undefined;
      startDate?: Date | undefined;
      duration?: number | undefined;
      completionPecentage?: number | undefined;
      status?: "NOT_STARTED" | "IN_PROGRESS" | "COMPLETED" | undefined;
      ganttColor?: string | undefined;
      kanbanColumnId?: string | undefined;
    } & { id: string },
  ) => {
    setConvertedData((prev) =>
      prev?.map((t) => {
        if (t.id === data.id) {
          return { ...t, ...data };
        }
        return t;
      }),
    );

    setGetError(data.id);
    taskUpdateMutation.mutate(data, {
      onSuccess() {
        setGetError("");
        props.refetch().finally(() => {
          setTimeout(() => {
            const task = convertedData?.find((t) => t.id == data.id);
            setNewTask(task);
          }, 600);
        });
        projectQuery.refetch();
      },
      onError(error) {
        if (
          error?.response?.data?.message?.includes(
            `Would you like to remove the dependency?`,
          ) ||
          error?.response?.data?.message?.includes(
            `Would you like to remove these dependencies?`,
          )
        ) {
          setErrorMessage(errorKeyFormate(error.response?.data.message + ""));
          if (data.startDate) {
            const startDate = new Date(data.startDate);
            startDate.setUTCHours(0, 0, 0, 0);
            startDate.setDate(startDate.getDate());
            setTaskNewDate(startDate.toISOString() as unknown as Date);
          }
        } else {
          props.refetch();
          toast.error(
            errorKeyFormate(error.response?.data.message + ""),
            errorConfig,
          );
        }
      },
    });
  };
  const taskDependenciesMutation = useTaskDependenciesMutation();
  const onDependencyCreate = (e: {
    from: { startTaskID: string; type: string };
    to: { endTaskID: string; type: string };
  }) => {
    let data = {
      dependendentOnTaskId: e.from.startTaskID,
      dependentType: TaskDependenciesEnumValue.PREDECESSORS,
      taskId: e.to.endTaskID,
    };
    if (data.dependendentOnTaskId && data.taskId) {
      taskDependenciesMutation.mutate(data, {
        onSuccess() {
          props.refetch();
          data = {
            dependendentOnTaskId: "",
            dependentType: "PREDECESSORS",
            taskId: "",
          };
        },
        onError(error) {
          data = {
            dependendentOnTaskId: "",
            dependentType: "PREDECESSORS",
            taskId: "",
          };

          toast.error(
            error.response?.data.message == "Unauthorized"
              ? t("gantt_chart_you_are_not_authorize")
              : errorKeyFormate(error.response?.data.message + ""),
            errorConfig,
          );
          props.refetch();
        },
      });
    }
  };
  const removeTaskDependenciesMutation = useRemoveTaskDependenciesMutation();
  const [removeDependencies, setRemoveDependencies] = useState<string>();

  const removeDependenciesFn = (e: {
    from: { id: string; type: string };
    to: { id: string; type: string };
  }) => {
    const fromTask = props.data.find((t) => t.taskId == e.to.id);
    const dependency = fromTask?.dependencies.find(
      (d) => d.dependendentOnTaskId == e.from.id,
    );
    setRemoveDependencies(dependency?.taskDependenciesId);
  };
  const handleRemoveDependencies = () => {
    if (removeDependencies) {
      removeTaskDependenciesMutation.mutate(removeDependencies ?? "", {
        onSuccess(res) {
          setRemoveDependencies("");
          toast.success(res.data.message);
          props.refetch();
        },
        onError(error) {
          props.refetch();
          setRemoveDependencies("");
          toast.error(
            error.response?.data.message == "Unauthorized"
              ? t(
                "You are not authorized to edit tasks which are not assigned to you",
              )
              : errorKeyFormate(error.response?.data.message + ""),
            errorConfig,
          );
        },
      });
    }
  };
  const removeTaskDependency = async () => {
    if (props.data) {
      if (updatedBy?.key == "percentbardrop") {
        const dependentTask = props.data.find((t) => t.taskId == getError);
        dependentTask?.dependencies.forEach(async (e) => {
          if (e.dependentType == TaskDependenciesEnumValue.PREDECESSORS) {
            await removeTaskDependenciesMutation.mutateAsync(
              e.taskDependenciesId,
              {
                onSuccess() {
                  reset();
                  UpdateApiCall({
                    id: getError ?? "",
                    completionPecentage: Number(updatedBy.value),
                  });
                },
                onError(error) {
                  reset();
                  toast.error(
                    error.response?.data.message == "Unauthorized"
                      ? t(
                        "You are not authorized to edit tasks which are not assigned to you",
                      )
                      : errorKeyFormate(error.response?.data.message + ""),
                    errorConfig,
                  );
                },
              },
            );
          }
        });
      } else {
        if (taskNewDate) {
          for (const data of props.data ?? []) {
            for (const item of data.dependencies) {
              const dependentTask = props.data.find(
                (t) =>
                  t.taskId == item.dependendentOnTaskId &&
                  t.taskId !== getError &&
                  t.endDate >= taskNewDate,
              );
              if (
                taskNewDate &&
                dependentTask?.endDate &&
                dependentTask.endDate >= taskNewDate &&
                item.dependentTaskId === getError &&
                item.dependentType === TaskDependenciesEnumValue.PREDECESSORS
              ) {
                if (item.taskDependenciesId && data.taskId) {
                  await removeTaskDependenciesMutation.mutateAsync(
                    item.taskDependenciesId,
                    {
                      onSuccess() {
                        props.refetch();
                      },
                      onError(error) {
                        toast.error(
                          error.response?.data.message == "Unauthorized"
                            ? t(
                              "You are not authorized to edit tasks which are not assigned to you",
                            )
                            : errorKeyFormate(
                              error.response?.data.message + "",
                            ),
                          errorConfig,
                        );
                      },
                    },
                  );
                }
              }
            }
          }
          if (updatedBy) {
            UpdateApiCall({
              id: getError ?? "",
              startDate: updatedBy.value as Date,
            });
          }
        }
      }

      setGetError("");
    }
  };
  const reset = () => {
    props.refetch();
    setGetError("");
    setErrorMessage("");
    setData();
  };
  const [taskEdit, setTaskEdit] = useState<string>();
  const [taskRemove, setTaskRemove] = useState("");

  const contextManu = (action: string, task: GanttTaskExtendedType) => {
    switch (action) {
      case "edit":
        setTaskEdit(task.id);
        break;
      case "createSubTask":
        setCreateSub(task.id);
        break;
      case "delete":
        setTaskRemove(task.id);
        break;
    }
  };
  const removeTaskMutation = useRemoveTaskMutation();
  const removeTask = (id: string) => {
    removeTaskMutation.mutate(id, {
      onSuccess(data) {
        toast.success(data.data.message);
        setTaskRemove("");
        props.refetch();
      },
      onError(error) {
        toast.error(errorKeyFormate(error.response?.data.message + ""));
        setTaskRemove("");
        props.refetch();
      },
    });
  };
  const updateHeight = () => {
    const nextHeight = Divref.current?.offsetHeight ? Divref.current.offsetHeight - 100 : 600;
    requestAnimationFrame(() => {
      setGanttHeight((prev) => (Math.abs(prev - nextHeight) > 2 ? nextHeight : prev));
    });
  };
  const [GanttHeight, setGanttHeight] = useState(600);
  const pdfCaptureRef = useRef(false);
  const downloadFnRef = useRef<() => void>(() => { });

  const handleDownloadGanttPdf = () => {
    if (!Divref.current || !props.data?.length) return;
    try {
      const parentTasks = getParentTasks(props.data);
      const allTasks = getTasksWithSubtasks(props.data, 0, parentTasks.length);
      const filteredTasks = allTasks.filter((task) =>
        allTasks.some((t) => t.taskId === task.parentTaskId)
          ? !task.parentTaskId
          : true,
      );
      const sortedTasks = filteredTasks.sort(
        (a, b) =>
          new Date(a.startDate).getTime() - new Date(b.startDate).getTime(),
      );
      const allConverted = sortedTasks.map((task) => convertTasks(task));
      const flattenedAll = sortAndFlattenTask(allConverted, true);
      setConvertedData(flattenedAll);
      pdfCaptureRef.current = true;
    } catch (error) {
      console.error("Failed to generate Gantt PDF", error);
      toast.error(errorKeyFormate("Failed to generate Gantt PDF"), errorConfig);
      props.handleDownloadGanttPdfComplete?.();
    }
  };

  downloadFnRef.current = handleDownloadGanttPdf;

  useEffect(() => {
    if (props.ganttPdfRef) {
      props.ganttPdfRef.current = {
        handleDownloadGanttPdf: () => downloadFnRef.current(),
      };
    }
    return () => {
      if (props.ganttPdfRef) {
        props.ganttPdfRef.current = null;
      }
    };
  }, [props.ganttPdfRef]);

  useEffect(() => {
    if (!pdfCaptureRef.current || !Divref.current) return;
    pdfCaptureRef.current = false;

    const capture = async () => {
      await new Promise((resolve) => setTimeout(resolve, 300));
      try {
        await downloadGanttAsPdf(Divref.current!, "tasks-gantt.pdf", {
          hideTaskList: true,
        });
      } catch (error) {
        console.error("Failed to generate Gantt PDF", error);
        toast.error(
          errorKeyFormate("Failed to generate Gantt PDF"),
          errorConfig,
        );
      } finally {
        setData();
        props.handleDownloadGanttPdfComplete?.();
      }
    };
    capture();
  }, [convertedData]);

  useEffect(() => {
    updateHeight();
    const resizeObserver = new ResizeObserver(updateHeight);

    if (Divref.current) {
      resizeObserver.observe(Divref.current);
    }
    return () => {
      resizeObserver.disconnect();
    };
  }, []);
  const onScroll = (event: SyntheticEvent<HTMLDivElement>) => {
    const target = event?.currentTarget;
    if (!target) return; // Ensure target is defined
    const scrollTop = target.scrollTop;
    const scrollHeight = target.scrollHeight;
    const clientHeight = target.clientHeight;
    const scrollThreshold = 10;

    // Assuming totalTasks represents the total number of tasks
    const totalTasks = getParentTasks(props.data).length;
    const maxTasksVisible = taskSlice + tasksIncrement;

    // Scroll down logic
    if (scrollTop + clientHeight >= scrollHeight - scrollThreshold) {
      if (maxTasksVisible < totalTasks) {
        setTaskSlice((prev) => prev + tasksIncrement);
        setTimeout(() => {
          target.scrollBy({ top: -200, behavior: "instant" });
        }, 100);
      }
    }

    // Scroll up logic
    else if (scrollTop === 0 && taskSlice > 0) {
      setTaskSlice((prev) => prev - tasksIncrement);

      setTimeout(() => {
        target.scrollBy({ top: 200, behavior: "instant" });
      }, 100);
    }
  };

  const allowed = (projectId: string, task: Task) => {
    const project = projectQuery.data?.data.data.find(
      (p) => p.projectId == projectId,
    );

    if (user?.userOrganisation[0]?.role === UserRoleEnumValue.ADMINISTRATOR) {
      return true;
    } else if (
      task?.assignedUsers.find((u) => u.user.userId === user?.userId) ||
      task?.createdByUserId == user?.userId
    ) {
      return true;
    } else if (
      project?.assignedUsers.find(
        (u) =>
          u.user.userId == user?.userId &&
          u.projectRole == UserRoleEnumValue.PROJECT_MANAGER,
      )
    ) {
      return true;
    }
    return false;
  };

  const currentUserProjectRoleGantt = useMemo(
    () =>
      project?.assignedUsers?.find((item) => item.user.userId === user?.userId)
        ?.projectRole,
    [project?.assignedUsers, user?.userId],
  );

  const canManageTasksGantt = useMemo(() => {
    if (!user || !project) return false;
    return canManageProjectTasksAndContent(
      user,
      user.userOrganisation[0]?.role,
      project.assignedUsers,
      normalizeProjectScope(project),
    );
  }, [user, project]);

  const bulkSelectAllowed = useCallback(
    (task: ApiTask | undefined): boolean => {
      const me = user;
      const proj = project;
      if (!me || !task || !proj) return false;
      if (
        proj.assignedUsers.find(
          (u) =>
            u.user.userId === me.userId &&
            u.projectRole === UserRoleEnumValue.TEAM_MEMBER,
        ) &&
        task.createdByUserId === me.userId
      ) {
        return true;
      }
      return canManageProjectTasksAndContent(
        me,
        me.userOrganisation[0]?.role,
        proj.assignedUsers,
        normalizeProjectScope(proj),
      );
    },
    [user, project],
  );

  const accumulateSubTaskIdsForBulk = useCallback(
    (taskId: string, taskArray: ApiTask[]): string[] => {
      const subTaskIds: string[] = [taskId];
      const hit = taskArray.find((ft) => ft.taskId === taskId);
      if (hit) {
        hit.subtasks?.forEach((st: ApiTask) => {
          subTaskIds.push(st.taskId);
          if (st.subtasks?.length) {
            subTaskIds.push(
              ...accumulateSubTaskIdsForBulk(st.taskId, taskArray),
            );
          }
        });
      }
      return subTaskIds;
    },
    [],
  );

  const toggleGanttBulkTask = useCallback(
    (taskId: string) => {
      if (!props.onBulkSelectedTaskIdsChange) return;
      const source = props.bulkSelectionSourceTasks ?? props.data;
      const subIds = accumulateSubTaskIdsForBulk(taskId, source);
      const current = props.bulkSelectedTaskIds ?? [];
      if (!current.includes(taskId)) {
        props.onBulkSelectedTaskIdsChange([
          ...new Set([...current, ...subIds]),
        ]);
      } else {
        props.onBulkSelectedTaskIdsChange(
          current.filter((t) => !subIds.includes(t)),
        );
      }
    },
    [
      props.bulkSelectionSourceTasks,
      props.data,
      props.bulkSelectedTaskIds,
      props.onBulkSelectedTaskIdsChange,
      accumulateSubTaskIdsForBulk,
    ],
  );

  useEffect(() => {
    props.onBulkSelectedTaskIdsChange?.([]);
  }, [props.data, props.onBulkSelectedTaskIdsChange]);

  const StarDate = useMemo(() => {
    if (convertedData && convertedData.length && convertedData[0]?.start) {
      const d = new Date(convertedData[0].start);
      if (!isNaN(d.getTime())) {
        d.setDate(d.getDate() + 1);
        return d;
      }
    }
    return null;
  }, [convertedData]);

  useEffect(() => {
    const task = props.data?.find((t) => t.taskId == props.selectedTaskId);
    if (task) {
      setTimeout(() => {
        setNewTask(convertTasks(task));
      }, 500);
    }
  }, [props.selectedTaskId, props.data]);
  const [scheduledError, setScheduledError] = useState("");
  const UserTooltipContent: React.FC<{
    task: any;
    fontSize: string;
    fontFamily: string;
    userId?: string;
  }> = ({ task, userId }) => {
    const user = task.assign?.find(
      (u: { user: UserType }) => u.user.userId === userId,
    )?.user;

    const findTask = props.data?.find((t) => t.taskId == task.id);
    if (task.showAll) {
      return (
        <div className="text-xs flex flex-col gap-1 mt-2 max-w-[220px]">
          <div className="font-semibold text-gray-700 flex justify-between">
            <div className="w-full"></div>
            <div className="text-nowrap">{t("Task Effort (%)")}</div>
          </div>
          {findTask?.assignedUsers.slice(5).map((u) => {
            const efforts = calculateTaskEffort(
              u?.workingHours ?? 8,
              findTask.duration ?? 1,
              8,
            );
            return (
              <div className="flex justify-between items-center">
                <span className="truncate mr-2">
                  {u.user?.firstName && u.user?.lastName
                    ? `${u.user.firstName} ${u.user.lastName}`
                    : u.user?.email}
                </span>
                {task.type == "task" && <span>{efforts}%</span>}
              </div>
            );
          })}
        </div>
      );
    }

    return (
      <div className="text-xs flex flex-col gap-1 max-w-[220px]">
        <div className="font-semibold text-gray-700 w-full"></div>
        <div className="flex justify-between">
          <span className="truncate">
            {user?.firstName && user?.lastName
              ? `${user.firstName} ${user.lastName}`
              : user?.email}
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-500 text-nowrap">
            {t("Task Effort (%)")}:
          </span>
          {task.type == "task" && <span>{task.efforts}%</span>}
        </div>
      </div>
    );
  };
  // Inside your table setup file/component

  const AssignedCell = React.memo(function AssignedCell({
    data,
  }: {
    data: any;
  }) {
    const assignRef = useRef<HTMLDivElement>(null);
    const [visibleCount, setVisibleCount] = useState(4); // default to 4

    useEffect(() => {
      if (!assignRef.current) return;

      const element = assignRef.current;

      const calculateVisibleCount = () => {
        const avatarWidth = 32;
        const spacing = 4;
        const containerWidth = element.clientWidth || 0;
        const maxCount = Math.floor(
          containerWidth / (avatarWidth - 8 + spacing),
        );
        setVisibleCount(maxCount > 0 ? maxCount - 2 : 0);
      };

      const resizeObserver = new ResizeObserver(() => {
        calculateVisibleCount();
      });

      resizeObserver.observe(element);

      // Initial call
      calculateVisibleCount();

      return () => {
        resizeObserver.disconnect();
      };
    }, []);

    const visibleAvatars = useMemo(() => {
      const assignList = data.assign ?? [];
      const visible = assignList.slice(0, visibleCount > 0 ? visibleCount : 1);
      const hiddenCount = Math.max(assignList.length - visible.length, 0);

      return (
        <>
          {visible.map((item: any, index: number) => {
            const efforts = calculateTaskEffort(
              item?.workingHours ?? 8,
              data.duration,
              8,
            );

            return (
              <TooltipProvider key={item.user?.userId ?? item.user?.email ?? index} delayDuration={0}>
                <Tooltip delayDuration={0}>
                  <TooltipTrigger>
                    <div className={`relative group ${index > 0 ? "" : ""}`}>
                      <UserAvatar
                        className="shadow-sm shadow-gray-300 border-2 border-white w-7 h-7"
                        user={item.user}
                      />
                    </div>
                  </TooltipTrigger>
                  <TooltipContent>
                    <div className="text-xs flex flex-col gap-1 max-w-[220px]">
                      <div className="font-semibold text-gray-700 w-full">
                        {item.user?.firstName && item.user?.lastName
                          ? `${item.user.firstName} ${item.user.lastName}`
                          : item.user?.email}
                      </div>
                      {data.type == "task" && (
                        <div className="flex justify-between">
                          <span className="text-gray-500 text-nowrap">
                            {t("Task Effort (%)")}:
                          </span>
                          <span>{efforts}%</span>
                        </div>
                      )}
                    </div>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            );
          })}

          {hiddenCount > 0 && (
            <TooltipProvider delayDuration={0}>
              <Tooltip delayDuration={0}>
                <TooltipTrigger>
                  <div
                    className="ml-1 w-7 h-7 aspect-square justify-center items-center flex  rounded-full bg-slate-200 outline-none"
                    data-userid={"all"}
                    data-showallassing="true"
                  >
                    +{hiddenCount}
                  </div>
                </TooltipTrigger>
                <TooltipContent>
                  <div className="text-xs flex flex-col gap-1 max-w-[220px]">
                    <div className="font-semibold text-gray-700 flex justify-between">
                      <div className="w-full"></div>
                      {data.type == "task" && (
                        <div className="text-nowrap">
                          {t("Task Effort (%)")}
                        </div>
                      )}
                    </div>
                    {(data.assign.slice(visibleCount) ?? []).map(
                      (hiddenItem: any, hiddenIndex: number) => {
                        const effort = calculateTaskEffort(
                          hiddenItem?.workingHours ?? 8,
                          data.duration,
                          8,
                        );
                        const userLabel =
                          hiddenItem.user?.firstName &&
                            hiddenItem.user?.lastName
                            ? `${hiddenItem.user.firstName} ${hiddenItem.user.lastName}`
                            : hiddenItem.user?.email;

                        return (
                          <div
                            key={hiddenItem.user?.userId ?? hiddenItem.user?.email ?? hiddenIndex}
                            className="flex justify-between items-center"
                          >
                            <span className="truncate mr-2">{userLabel}</span>
                            {data.type == "task" && (
                              <div className="flex justify-between">
                                <span>{effort}%</span>
                              </div>
                            )}
                          </div>
                        );
                      },
                    )}
                  </div>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          )}
        </>
      );
    }, [data.assign, data.duration, visibleCount]);

    return (
      <div className="ml-3 flex w-full !overflow-hidden" ref={assignRef}>
        {visibleAvatars}
      </div>
    );
  });

  const [hiddenColumns, setHiddenColumns] = useState<string[]>(() => {
    try {
      const stored = localStorage.getItem("hidden_columns");
      if (!stored) {
        localStorage.setItem(
          "hidden_columns",
          JSON.stringify([
            "PREDECESSORS",
            "SUCCESSORS",
            "milestone",
            "parentTask",
            "delay",
          ]),
        );
      }
      return stored
        ? JSON.parse(stored)
        : ["PREDECESSORS", "SUCCESSORS", "milestone", "parentTask", "delay"];
    } catch {
      console.error("error in hiddenColumns");
    }
  });
  const [sortCol, setSortCol] = useState<any>([]);
  const taskStatus = (data: any) => {
    const removeStatus = [TaskStatusEnumValue.IN_PROGRESS];
    if (data?.type == "milestone") {
      return Object.keys(TaskStatusEnumValue).filter(
        (e) => !removeStatus?.some((r) => e === r),
      );
    } else {
      return Object.keys(TaskStatusEnumValue);
    }
  };
  const uniqueHiddenColumns = useMemo(
    () => Array.from(new Set(hiddenColumns)),
    [hiddenColumns, sortCol],
  );
  const allCols = useMemo(() => {
    const bulkSourceIds =
      props.bulkSelectionSourceTasks?.map((r) => r.taskId) ?? [];
    const bulkSelectedCount = props.bulkSelectedTaskIds?.length ?? 0;
    const allBulkSelected =
      bulkSourceIds.length > 0 &&
      bulkSourceIds.every((id) =>
        (props.bulkSelectedTaskIds ?? []).includes(id),
      );

    const bulkSelectColumn = props.onBulkSelectedTaskIdsChange
      ? [
        {
          field: "bulkSelect",
          name: "",
          width: 44,
          nonDragable: true,
          headerRender() {
            if (
              !(
                canManageTasksGantt ||
                currentUserProjectRoleGantt !==
                UserRoleEnumValue.TEAM_MEMBER
              )
            ) {
              return <span className="inline-block w-4" />;
            }
            if (bulkSelectedCount === 0) {
              return (
                <div
                  data-gantt-bulk-header-hit
                  className="flex h-full min-h-[28px] w-full items-center justify-center px-1"
                >
                  <div className="bulk-header-select-reveal flex justify-center opacity-0 transition-opacity duration-150">
                    <input
                      type="checkbox"
                      aria-label="Select all tasks"
                      onChange={(e) => {
                        e.stopPropagation();
                        if (e.target.checked) {
                          props.onBulkSelectedTaskIdsChange?.(bulkSourceIds);
                        } else {
                          props.onBulkSelectedTaskIdsChange?.([]);
                        }
                      }}
                      checked={allBulkSelected}
                    />
                  </div>
                </div>
              );
            }
            return (
              <div className="flex w-full justify-center px-1">
                <div className="bulk-header-select-reveal flex justify-center opacity-100 transition-opacity duration-150">
                  <input
                    type="checkbox"
                    aria-label="Select all tasks"
                    onChange={(e) => {
                      e.stopPropagation();
                      if (e.target.checked) {
                        props.onBulkSelectedTaskIdsChange?.(bulkSourceIds);
                      } else {
                        props.onBulkSelectedTaskIdsChange?.([]);
                      }
                    }}
                    checked={allBulkSelected}
                  />
                </div>
              </div>
            );
          },
          render(data: GanttTaskExtendedType) {
            const apiTask = props.data.find((t) => t.taskId === data.id);
            const source = props.bulkSelectionSourceTasks ?? props.data;
            const treeTask = source.find((t) => t.taskId === data.id);
            return (
              <div
                className={cn(
                  "bulk-select-reveal flex justify-center px-1 transition-opacity duration-150",
                  bulkSelectedCount === 0 ? "opacity-0" : "opacity-100",
                )}
                onClick={(e) => e.stopPropagation()}
              >
                <input
                  type="checkbox"
                  checked={(props.bulkSelectedTaskIds ?? []).includes(
                    data.id,
                  )}
                  disabled={!bulkSelectAllowed(treeTask ?? apiTask)}
                  onChange={() => toggleGanttBulkTask(data.id)}
                />
              </div>
            );
          },
        },
      ]
      : [];

    const col = [
      ...bulkSelectColumn,
      {
        field: "name",
        name: t("task_name"),
        width: 380,
        headerRender() {
          return (
            <span
              data-gantt-task-name-header
              className="inline-flex items-center gap-1"
            >
              {t("task_name")}
            </span>
          );
        },
        sortable: true,
        render: (data: GanttTaskExtendedType) => {
          const isEditing =
            editingCell?.rowId === data.id && editingCell?.field === "name";
          const task = props.data.find((t) => t.taskId == data.id);
          const activeRisks =
            task?.taskRisks?.filter(
              (tr) => tr.risk?.status !== StatusEnumSchema.CLOSE,
            ) ?? [];
          return (
            <div
              data-gantt-task-name
              className="flex h-full w-full min-w-0 items-center gap-1 px-2"
            >
              {isEditing ? (
                <InputText
                  tabIndex={-1}
                  defaultValue={editingValue as string}
                  onChange={(e) => setEditingValue(e.target.value)}
                  onBlur={() => handleBlur(data)}
                  onKeyDown={(e) => handleKeyDown(e, data)}
                  autoFocus
                  className="w-full h-auto mb-2"
                />
              ) : (
                <div className="flex w-full min-w-0 flex-1 items-center">
                  <div
                    className="inline-flex max-w-full min-w-0 flex-1 cursor-default items-center gap-1"
                  >
                    <div className="flex min-w-0 shrink-0 items-center gap-1">
                      <div className="flex w-12 items-center gap-1">
                        {activeRisks.length > 0 && (
                          <TooltipProvider delayDuration={0}>
                            <Tooltip>
                              <TooltipTrigger asChild>
                                <img src={Extermination} className="h-3 w-3" />
                              </TooltipTrigger>
                              <TooltipContent
                                side="bottom"
                                className="max-w-[240px]"
                              >
                                <div className="flex flex-col max-w-60 w-60 font-semibold gap-0.5 text-sm">
                                  {t("AssociatedRisk")}
                                  <div className="w-52 mt-2 text-xs truncate font-normal ">
                                    {activeRisks
                                      ?.slice()
                                      .reverse()
                                      .slice(0, 3)
                                      .map((att) => {
                                        return (
                                          <div
                                            key={att.taskRiskId}
                                            className="truncate cursor-pointer w-52 mt-1"
                                            onClick={() => {
                                              if (att.riskId && projectId) {
                                                navigate(`/risk/${projectId}`, {
                                                  state: att.risk,
                                                });
                                                window.history.replaceState({}, "");
                                              }
                                            }}
                                          >
                                            {att.risk?.riskNameId} : {att.risk?.title}
                                          </div>
                                        );
                                      })}
                                    {(
                                      <div
                                        className="w-52 flex justify-end mt-4 mb-2 mr-3 text-secondary underline cursor-pointer"
                                        onClick={() => {
                                          navigate(`/risk/${projectId}?impactedTasks=${task?.taskId}`);
                                        }}
                                      >
                                        {t("show more")}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </TooltipContent>
                            </Tooltip>
                          </TooltipProvider>
                        )}
                        {task?.documentAttachments &&
                          task?.documentAttachments?.length > 0 && (
                            <TooltipProvider delayDuration={0}>
                              <Tooltip >
                                <TooltipTrigger asChild>
                                  <button
                                    type="button"
                                    className="p-0 border-0 bg-transparent cursor-pointer inline-flex items-center"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setTaskEdit(data.id);
                                    }}
                                  >
                                    <img
                                      src={BlueAttachment}
                                      className="h-3 w-3"
                                      alt={t("Attachments")}
                                    />
                                  </button>
                                </TooltipTrigger>
                                <TooltipContent
                                  side="bottom"
                                  className="max-w-[240px]"
                                >
                                  <div className="flex flex-col font-semibold w-60 gap-0.5 text-sm">
                                    {t("attachment")}
                                    <div className="w-52 mt-2 text-xs truncate font-normal ">
                                      {task.documentAttachments
                                        ?.slice()
                                        .reverse()
                                        .slice(0, 3)
                                        .map((att) => {
                                          const displayName =
                                            att.label && att.label.trim() !== ""
                                              ? att.label === "link" ? att.name : att.label
                                              : att.name;
                                          return (
                                            <div
                                              key={att.attachmentId}
                                              className="truncate w-52 mt-1"
                                            >
                                              {displayName}
                                            </div>
                                          );
                                        })}
                                      {<div
                                        className="w-52 flex justify-end mt-4 mb-2 mr-3 text-secondary underline cursor-pointer"
                                        onClick={() => {
                                          setTaskEdit(task.taskId);
                                        }}
                                      >
                                        {t("show more")}
                                      </div>}
                                    </div>
                                  </div>
                                </TooltipContent>
                              </Tooltip>
                            </TooltipProvider>
                          )}
                        {task?.taskNotes && task?.taskNotes?.length > 0 && (
                          <TooltipProvider delayDuration={0}>
                            <Tooltip>
                              <TooltipTrigger asChild>
                                <button
                                  type="button"
                                  className="p-0 border-0 bg-transparent cursor-pointer inline-flex items-center"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setTaskEdit(data.id);
                                  }}
                                >
                                  <img
                                    src={Note}
                                    className="h-3 w-3"
                                    alt={t("Attachments")}
                                  />
                                </button>
                              </TooltipTrigger>
                              <TooltipContent
                                side="bottom"
                                className="max-w-[240px]"
                              >
                                <div className="flex flex-col max-w-60 w-60 font-semibold gap-0.5 text-sm">
                                  {t("notes")}
                                  <div className="w-52 mt-2 text-xs font-normal">
                                    <ol className="!list-disc ">
                                      {task?.taskNotes
                                        ?.slice() // create copy so original array is not mutated
                                        .reverse() // newest first
                                        .slice(0, 3) // take only 3 notes
                                        .map((note) => {
                                          return (
                                            <li
                                              key={note.noteId}
                                              className="w-52 truncate mt-1"
                                            >
                                              {note.note}
                                            </li>
                                          );
                                        })}
                                    </ol>
                                    {<div
                                      className="w-52 flex justify-end mt-4 mb-2 mr-3 text-secondary underline cursor-pointer"
                                      onClick={() => {
                                        setTaskEdit(task.taskId);
                                      }}
                                    >
                                      {t("show more")}
                                    </div>}
                                  </div>
                                </div>
                              </TooltipContent>
                            </Tooltip>
                          </TooltipProvider>
                        )}
                      </div>
                    </div>
                    {data.flag == "Green" ? (
                      <img src={GreenFlag} className="h-3 w-3 shrink-0" />
                    ) : data.flag == "Red" ? (
                      <img src={RedFlag} className="h-3 w-3 shrink-0" />
                    ) : data.flag == "Orange" ? (
                      <img src={OrangeFlag} className="h-3 w-3 shrink-0" />
                    ) : (
                      ""
                    )}
                    <div
                      className="min-w-0 flex-1 break-words truncate"
                      onClick={() => {
                        if (isProjectEditBlocked) {
                          setIsProjectEditBlockedDialogOpen(true);
                          return;
                        }
                        if (task && allowed(projectId ?? "", task)) {
                          setEditingCell({ rowId: data.id, field: "name" });
                          setEditingValue(data.name);
                        }
                      }}
                      title={data.name}
                    >
                      {data.name}
                    </div>
                  </div>
                </div>
              )}
            </div>
          );
        },
      },
      {
        field: "assign",
        name: t("Assigned"),
        headerRender() {
          return <> {t("Assigned")} </>;
        },
        width: 100,
        render: (data: any) => <AssignedCell data={data} />,
      },
      {
        field: "start",
        name: t("start_date"),
        headerRender() {
          return <> {t("start_date")} </>;
        },
        sortable: true,
        width: 120,
        render: (data: GanttTaskExtendedType) => {
          const isEditing =
            editingCell?.rowId === data.id && editingCell?.field === "start";
          const task = props.data.find((t) => t.taskId == data.id);

          return (
            <div
              className="w-full flex justify-center items-center"
              onClick={() => {
                if (isProjectEditBlocked) {
                  setIsProjectEditBlockedDialogOpen(true);
                  return;
                }
                if (
                  task &&
                  allowed(projectId ?? "", task) &&
                  data.type !== "project"
                ) {
                  setEditingCell({ rowId: data.id, field: "start" });
                  setEditingValue(dateFormater(data.start));
                }
              }}
            >
              {isEditing ? (
                <input
                  type="date"
                  value={editingValue as string}
                  onChange={(e) => setEditingValue(e.target.value)}
                  onBlur={() => handleBlur(data)}
                  onKeyDown={(e) => handleKeyDown(e, data)}
                  autoFocus
                  className="w-full"
                />
              ) : (
                dateFormater(data.start)
              )}
            </div>
          );
        },
      },
      {
        field: "duration",
        name: t("Duration"),
        sortable: true,
        width: 120,
        headerRender() {
          return <> {t("Duration")} </>;
        },
        render: (data: GanttTaskExtendedType) => {
          const isEditing =
            editingCell?.rowId === data.id && editingCell?.field === "duration";
          const task = props.data.find((t) => t.taskId == data.id);
          return (
            <div
              className="w-full flex justify-center items-center p-2"
              onClick={() => {
                if (isProjectEditBlocked) {
                  setIsProjectEditBlockedDialogOpen(true);
                  return;
                }
                if (
                  task &&
                  allowed(projectId ?? "", task) &&
                  data.type !== "project"
                ) {
                  setEditingCell({ rowId: data.id, field: "duration" });
                  setEditingValue(data.duration);
                }
              }}
            >
              {isEditing ? (
                <input
                  type="number"
                  value={editingValue as number}
                  onChange={(e) => setEditingValue(Number(e.target.value))}
                  onBlur={() => handleBlur(data)}
                  onKeyDown={(e) => handleKeyDown(e, data)}
                  autoFocus
                  className="w-full h-auto py-1.5 px-3 rounded-lg border border-gray-100 mt-2  focus:outline-primary-400"
                />
              ) : (
                data.duration
              )}
            </div>
          );
        },
      },
      {
        field: "end",
        name: t("end_date"),
        sortable: true,
        width: 120,
        headerRender() {
          return <> {t("end_date")} </>;
        },
        render: (data: any) => {
          return (
            <div className="w-full flex justify-center items-center">
              {dateFormater(data.end)}
            </div>
          );
        },
      },
      {
        field: "progress",
        name: t("Actual Progress"),
        sortable: true,
        headerRender() {
          return <> {t("Actual Progress")} </>;
        },
        width: 120,
        render: (data: GanttTaskExtendedType) => {
          const isEditing =
            editingCell?.rowId === data.id && editingCell?.field === "progress";
          const task = props.data.find((t) => t.taskId == data.id);
          return (
            <div
              className="w-full flex justify-center items-center p-2"
              onClick={() => {
                if (isProjectEditBlocked) {
                  setIsProjectEditBlockedDialogOpen(true);
                  return;
                }
                if (
                  data?.type == "task" &&
                  task &&
                  allowed(projectId ?? "", task)
                ) {
                  const today = new Date();
                  const todayDateOnly = new Date(
                    today.getFullYear(),
                    today.getMonth(),
                    today.getDate(),
                  );

                  const startDate = new Date(data.start ?? "");
                  const startDateOnly = new Date(
                    startDate.getFullYear(),
                    startDate.getMonth(),
                    startDate.getDate(),
                  );

                  // If task starts in the future, block the update
                  if (startDateOnly > todayDateOnly) {
                    setScheduledError(data.id);
                    return;
                  }
                  setEditingCell({ rowId: data.id, field: "progress" });
                  setEditingValue(data.progress);
                }
              }}
            >
              {isEditing ? (
                <input
                  type="number"
                  max={100}
                  value={editingValue as number}
                  onChange={(e) =>
                    setEditingValue(
                      Number(e.target.value) >= 100
                        ? 100
                        : Number(e.target.value),
                    )
                  }
                  onBlur={() => handleBlur(data)}
                  onKeyDown={(e) => handleKeyDown(e, data)}
                  autoFocus
                  className="w-full h-auto py-1.5 px-3 rounded-lg border border-gray-100 mt-2  focus:outline-primary-400"
                />
              ) : (
                <PercentageCircle
                  percentage={data.progress}
                  roundColor={`${data.flag == "Green"
                    ? "#34D399"
                    : data.flag == "Red"
                      ? "#FB7185"
                      : data.flag == "Orange"
                        ? "#FBBF24"
                        : ""
                    } `}
                />
              )}
            </div>
          );
        },
      },
      {
        field: "plannedProgression",
        name: t("Expacted Progress"),
        sortable: true,
        headerRender() {
          return <> {t("Expacted Progress")} </>;
        },
        width: 120,
        render: (data: GanttTaskExtendedType) => {
          return (
            <div
              className="w-full flex justify-center items-center p-2"

            >
              <PercentageCircle
                percentage={Math.min(data?.plannedProgression ?? 0, 100)}
                roundColor={`${data.flag == "Green"
                  ? "#34D399"
                  : data.flag == "Red"
                    ? "#FB7185"
                    : data.flag == "Orange"
                      ? "#FBBF24"
                      : ""
                  } `}
              />
            </div>
          );
        },
      },
      {
        field: "status",
        name: t("status"),
        sortable: true,
        width: 160,
        headerRender() {
          return <> {t("status")} </>;
        },
        render(data: any) {
          const task = props.data.find((t) => t.taskId == data.id);
          return (
            <div className="w-full flex justify-center items-center p-2">
              <div className="flex justify-center items-center w-full">
                <DropdownMenu>
                  <DropdownMenuTrigger
                    asChild
                    disabled={
                      !isProjectEditBlocked ? Boolean(data?.type == "project") || ((data?.type == "task" || data?.type == "milestone") && task && !allowed(projectId ?? "", task)) : isProjectEditBlocked
                    }
                    onClick={() => {
                      if (isProjectEditBlocked) {
                        setIsProjectEditBlockedDialogOpen(true);
                        return;
                      }
                      setEditingCell(null);
                    }}
                  >
                    <div className={"text-sm font-normal cursor-pointer"}>
                      <div
                        className={`w-32 h-8 px-3 py-1.5 ${getStatusColor(
                          data.status,
                        )} rounded justify-center items-center gap-px inline-flex`}
                      >
                        <div className="text-sm font-medium leading-tight">
                          {t(data.status)}
                        </div>
                      </div>
                    </div>
                  </DropdownMenuTrigger>
                  {/* Dropdown menu content is fine as w-auto */}
                  <DropdownMenuContent className="w-auto">
                    {taskStatus(data).map((status) => {
                      return (
                        <div
                          key={status}
                          onClick={() => {
                            let completionPecentage = Number(data.progress);
                            if (status == TaskStatusEnumValue.NOT_STARTED) {
                              completionPecentage = 0;
                            } else if (
                              status == TaskStatusEnumValue.IN_PROGRESS
                            ) {
                              completionPecentage = 50;
                            } else if (
                              status == TaskStatusEnumValue.COMPLETED
                            ) {
                              completionPecentage = 100;
                            }
                            const today = new Date();
                            const todayDateOnly = new Date(
                              today.getFullYear(),
                              today.getMonth(),
                              today.getDate(),
                            );

                            const startDate = new Date(data.start ?? "");
                            const startDateOnly = new Date(
                              startDate.getFullYear(),
                              startDate.getMonth(),
                              startDate.getDate(),
                            );

                            // If task starts in the future, block the update
                            if (startDateOnly > todayDateOnly) {
                              setScheduledError(data.id);
                              return;
                            } else {
                              UpdateApiCall({
                                id: data.id,
                                status: status as any,
                                completionPecentage,
                              });
                            }
                          }}
                          className="cursor-pointer flex px-3 w-44 rounded-md hover:bg-slate-50/80 py-2 justify-between items-center"
                        >
                          {t(status)}
                          <CheckIcon
                            className={cn(
                              "ml-auto h-4 w-4",
                              status === data?.status
                                ? "opacity-100"
                                : "opacity-0",
                            )}
                          />
                        </div>
                      );
                    })}
                  </DropdownMenuContent>
                </DropdownMenu>
              </div>
            </div>
          );
        },
      },
      {
        field: "delay",
        headerRender() {
          return (
            <div className="flex gap-2 items-center justify-center w-full ">
              {" "}
              <div className=" truncate">{t("delay")}</div>
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger className="flex gap-1  items-center">
                    <img
                      src={InfoCircle}
                      className="min-w-4 w-4 brightness-0 "
                      alt="InfoCircle"
                    />
                  </TooltipTrigger>
                  <TooltipContent>
                    <p
                      className="text-sm  h-full text-left text-wrap"
                      dangerouslySetInnerHTML={{
                        __html: t("Task Progress Indicator", {
                          lowThreshold:
                            100 -
                            (user?.userOrganisation?.[0]?.organisation
                              ?.moderateDelayMax ?? 20),
                          midThreshold:
                            100 -
                            (user?.userOrganisation?.[0]?.organisation
                              ?.onTimeDelayMax ?? 5),
                          highThreshold: 100,
                        }),
                      }}
                    ></p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>{" "}
            </div>
          );
        },
        name: t("delay"),
        width: 250,
        render(data: any) {
          const task = props.data.find((t) => t.taskId === data.id);
          return (
            <div className="w-full text-center">
              {typeof task?.tpi === "number"
                ? `${(task.tpi * 100).toFixed(0)}%`
                : "-"}
            </div>
          );
        },
      },
      {
        field: "PREDECESSORS",
        name: t(TaskDependenciesEnumValue.PREDECESSORS),
        width: 160,
        headerRender() {
          return <> {t("PREDECESSORS")} </>;
        },
        render(data: any) {
          const task = props.data.find((t) => t.taskId === data.id);
          const dependency = task?.dependencies
            .filter(
              (d) => d.dependentType === TaskDependenciesEnumValue.PREDECESSORS,
            )
            .map(
              (d) =>
                props.data.find((t) => t.taskId === d.dependendentOnTaskId)
                  ?.taskName ?? "",
            )
            .join(", ");
          return dependency;
        },
      },
      {
        field: "SUCCESSORS",
        name: t(TaskDependenciesEnumValue.SUCCESSORS),
        headerRender() {
          return <> {t("SUCCESSORS")} </>;
        },
        width: 160,
        render(data: any) {
          const task = props.data.find((t) => t.taskId === data.id);
          const dependency = task?.dependencies
            .filter(
              (d) => d.dependentType === TaskDependenciesEnumValue.SUCCESSORS,
            )
            .map(
              (d) =>
                props.data.find((t) => t.taskId === d.dependendentOnTaskId)
                  ?.taskName ?? "",
            )
            .join(", ");
          return dependency;
        },
      },
      {
        field: "type",
        headerRender() {
          return <> {t("milestone")} </>;
        },
        name: t("milestone"),
        sortable: true,
        width: 120,
        render(data: any) {
          return data?.type == "milestone" ? "Yes" : "No";
        },
      },
      {
        field: "parentTask",
        headerRender() {
          return <> {t("parent_task")} </>;
        },
        name: t("parent_task"),
        width: 180,
        render(data: any) {
          const task = props.data.find((t) => t.taskId === data.project);
          return task?.taskName || "-";
        },
      },
    ];

    if (uniqueHiddenColumns.length > 0) {
      col.push({
        field: "add new column",
        name: t("add_column"),
        width: 160,
        headerRender() {
          return (
            <DropdownMenu>
              <DropdownMenuTrigger>{t("add_column")}</DropdownMenuTrigger>
              <DropdownMenuContent>
                {uniqueHiddenColumns.map((key) => {
                  const field = col.find((t: any) => t.field == key)?.name;
                  return (
                    <DropdownMenuItem key={key} onSelect={() => AddColumn(key)}>
                      <div className="h-full w-full cursor-pointer">
                        {t(field ?? "")}
                      </div>
                    </DropdownMenuItem>
                  );
                })}
              </DropdownMenuContent>
            </DropdownMenu>
          );
        },
        render() {
          return <></>;
        },
      });
    }
    if (!sortCol.length) {
      setSortCol(
        col.map((t) => {
          return { field: t.field, width: t.width };
        }),
      );
    }
    return col;
  }, [
    t,
    props.data,
    props.bulkSelectedTaskIds,
    props.bulkSelectionSourceTasks,
    props.onBulkSelectedTaskIdsChange,
    editingCell,
    editingValue,
    hiddenColumns,
    sortCol,
    bulkSelectAllowed,
    toggleGanttBulkTask,
    canManageTasksGantt,
    currentUserProjectRoleGantt,
  ]);
  useEffect(() => {
    // columns that were unhidden
    const unhidden = allCols.filter(
      (col) => !uniqueHiddenColumns.includes(col.field),
    );

    // find specific column
    const find = unhidden.find((t) => t.field === "add new column");

    if (find) {
      setSortCol((prev: any) => {
        if (!prev.some((t: any) => t.field === find.field)) {
          return [...prev, { field: find.field, width: find.width }];
        }
        return prev;
      });
    }
  }, [uniqueHiddenColumns, allCols]);

  const visibleCols = useMemo(() => {
    const filteredCols = allCols.filter(
      (c: any) => !hiddenColumns.includes(c.field),
    );
    if (sortCol && sortCol.length > 0) {
      const sortedCol = sortCol
        .map((element: any) =>
          filteredCols.find((t) => t.field == element.field)
            ? {
              ...filteredCols.find((t) => t.field == element.field)!,
              width: element.width,
            }
            : null,
        )
        .filter(Boolean); // remove nulls in case sortCol has old fields
      return sortedCol.length > 0 ? sortedCol : filteredCols;
    }
    return filteredCols;
  }, [allCols, hiddenColumns, sortCol]);

  const AddColumn = (field: string) => {
    if (hiddenColumns.includes(field)) {
      const updated = hiddenColumns.filter((item) => item !== field);
      localStorage.setItem("hidden_columns", JSON.stringify(updated));

      const findcol = allCols.find((item) => item.field === field);
      if (findcol) {
        setSortCol((prev: any) => {
          // Always work from the current allCols order
          const baseCols = prev.length
            ? prev
            : allCols.map((c) => ({ field: c.field, width: c.width }));

          // Avoid duplicates
          if (baseCols.some((c: any) => c.field === findcol.field))
            return baseCols;

          // Insert before the "add new column" field if it exists
          const insertIndex = Math.max(baseCols.length - 1, 0);
          const newCol = [...baseCols];
          newCol.splice(insertIndex, 0, {
            field: findcol.field,
            width: findcol.width,
          });
          return newCol;
        });
      }

      setHiddenColumns(updated);
    }
  };

  const hideColumn = (field: any[]) => {
    setSortCol(
      field.map((t) => {
        return { field: t.field, width: t.width };
      }),
    );
    const stored = localStorage.getItem("hidden_columns") ?? "";
    setHiddenColumns(JSON.parse(stored));
  };

  useEffect(() => {
    updateHeight();
  }, [editingCell, hiddenColumns, allCols, visibleCols, sortCol]);
  return (
    <div className="h-full w-full" ref={Divref}>
      {convertedData && projectId && (
        <div className="h-full w-full">
          <Gantt
            bulkMultiSelectActive={(props.bulkSelectedTaskIds?.length ?? 0) > 0}
            setIsProject={setIsProject}
            UserTooltipContentComp={UserTooltipContent}
            onScroll={(e) => {
              onScroll(e);
            }}
            projectName={project?.projectName ?? ""}
            taskSorted={setConvertedData as any}
            setColumns={hideColumn}
            newTask={newTask}
            projectStartDate={
              StarDate
                ? StarDate
                : project?.startDate
                  ? new Date(project?.startDate)
                  : new Date()
            }
            projectEndDate={endDate}
            resourcesTask={!isProject ? resourcesTask : []}
            resourceMember={projectDetailQuery.data?.data.data.assignedUsers}
            columns={visibleCols as any}
            onDoubleClick={(e) => {
              setTaskEdit(e.id);
            }}
            onColorChange={(e) => {
              setConvertedData(
                convertedData.map((t) => {
                  if (t.id === e.id) {
                    t.styles = e.styles;
                    return t;
                  } else {
                    return t;
                  }
                }),
              );
              UpdateApiCall({
                ganttColor: e.styles?.backgroundColor,
                id: e.id,
              });
            }}
            viewMode={view}
            tasks={convertedData}
            preStepsCount={2}
            onDateChange={(e) => {
              updateTaskFromGanttView(e as GanttTaskExtendedType);
            }}
            onContextManuEvent={(e) => {
              contextManu(e.action, e.data as GanttTaskExtendedType);
            }}
            ganttHeight={GanttHeight}
            onProgressChange={(e) => {
              const today = new Date();
              const todayDateOnly = new Date(
                today.getFullYear(),
                today.getMonth(),
                today.getDate(),
              );

              const startDate = new Date(e.start ?? "");
              const startDateOnly = new Date(
                startDate.getFullYear(),
                startDate.getMonth(),
                startDate.getDate(),
              );

              // If task starts in the future, block the update
              if (startDateOnly > todayDateOnly) {
                setScheduledError(e.id);
                return;
              } else {
                setConvertedData(
                  convertedData.map((t) => {
                    if (t.id === e.id) {
                      t.progress = e.progress;
                      return t;
                    } else {
                      return t;
                    }
                  }),
                );
                updateTaskFromGanttView(e as GanttTaskExtendedType);
              }
              // UpdateApiCall({ completionPecentage: e.progress, id: e.id });
            }}
            onExpanderClick={(e) => expandToggle(e.id)}
            holidays={
              user?.userOrganisation[0].organisation.orgHolidays?.map(
                (h) => new Date(h.holidayStartDate),
              ) ?? []
            }
            nonWorkingDays={nonWorkingDays()}
            onDepandancyDragEnd={function (
              from: { startTaskID: string; type: string },
              to: { endTaskID: string; type: string },
            ): void {
              if (isProjectEditBlocked) {
                setIsProjectEditBlockedDialogOpen(true);
                return;
              }
              const task = props.data.find(
                (t) => t.taskId === from.startTaskID,
              );
              if (
                from.startTaskID !== to.endTaskID &&
                task &&
                allowed(projectId, task)
              ) {
                onDependencyCreate({ from, to });
              } else {
                toast.error(t("You are not allowed to create this dependency"));
              }
            }}
            onDepandanyClick={function (data: {
              from: { id: string; type: string };
              to: { id: string; type: string };
            }): void {
              const task = props.data.find((t) => t.taskId === data.from.id);
              if (task && allowed(projectId, task)) {
                removeDependenciesFn(data);
              } else {
                toast.error(t("You can't delete a dependencies"));
              }
            }}
            workloadLoader={isPending}
            apiResourceData={isProject ? taskSorted : undefined}
            onDepandancyDraging={function (
              from: { startTaskID: string; type: string },
              to: { endTaskID: string; type: string },
            ): void {
              console.log(from, to);
            }}
            setAPIData={(data) => {
              setinPercentage(data.inPercentage);
            }}
            ContextMenuContent={(props) => (
              <CustomGanttContextMenuContentForProjectTaskView
                project={project}
                user={user}
                {...props}
              />
            )}
            showWorkload={props.IsOpenWorkLoad}
          />
        </div>
      )}
      {Boolean(taskEdit) && (
        <TaskSubTaskForm
          taskId={taskEdit}
          projectId={projectId}
          createSubtask={createSub}
          close={(taskId) => {
            props.refetch().then(() => {
              const task = props.data?.find((t) => t.taskId == taskId);
              if (task) {
                setTimeout(() => {
                  setNewTask(convertTasks(task));
                }, 500);
              }
              projectQuery.refetch();
              setTaskEdit(undefined);
            });
          }}
        />
      )}
      {createSub && (
        <TaskSubTaskForm
          projectId={projectId}
          createSubtask={createSub}
          close={() => {
            props.refetch().then(() => {
              setCreateSub(undefined);
              projectQuery.refetch();
            });
          }}
        />
      )}
      <Dialog
        isOpen={Boolean(taskRemove)}
        onClose={() => { }}
        modalClass="rounded-lg"
      >
        <div className="flex flex-col gap-2 p-6 ">
          <img src={TrashCan} className="w-12 m-auto" />
          {t("common_delete_message")}
          <div className="flex gap-2 ml-auto">
            <Button variant={"outline"} onClick={() => setTaskRemove("")}>
              {t("cancel")}
            </Button>
            <Button
              variant={"primary"}
              isLoading={removeTaskMutation.isPending}
              disabled={removeTaskMutation.isPending}
              onClick={() => removeTask(taskRemove)}
            >
              {t("delete")}
            </Button>
          </div>
        </div>
      </Dialog>
      <Dialog
        isOpen={removeDepandancy}
        onClose={function (): void { }}
        modalClass="flex w-fit rounded-md"
      >
        <div className="w-fit flex flex-col justify-between items-center gap-10 p-5">
          {t("Do you want to delete this dependency?")}
          <div className="flex gap-3">
            <button
              className="py-2 px-3 bg-red-400 rounded-md"
              onClick={() => setRemoveDepandancy(null)}
            >
              {" "}
              cancel{" "}
            </button>
            <button
              className="py-2 px-3 bg-green-400 rounded-md"
              onClick={() => removeDepandancyFn()}
            >
              {" "}
              delete{" "}
            </button>
          </div>
        </div>
      </Dialog>
      <Dialog
        isOpen={Boolean(getError && errorMessage)}
        onClose={() => { }}
        modalClass="rounded-lg w-1/2 text-center"
      >
        <div className="flex flex-col gap-2 p-6 ">
          <img src={TrashCan} className="w-12 m-auto" /> {errorMessage}
          <div className="flex  gap-2 ml-auto">
            <Button
              variant={"outline"}
              onClick={() => {
                reset();
              }}
              isLoading={removeTaskDependenciesMutation.isPending}
              disabled={removeTaskDependenciesMutation.isPending}
            >
              {t("cancel")}
            </Button>
            <Button
              variant={"primary"}
              onClick={() => {
                removeTaskDependency();
              }}
            >
              {t("delete")}
            </Button>
          </div>
        </div>
      </Dialog>
      <Dialog
        isOpen={Boolean(removeDependencies)}
        onClose={() => { }}
        modalClass="rounded-lg"
      >
        <div className="flex flex-col gap-2 p-6 ">
          <img src={TrashCan} className="w-12 m-auto" />{" "}
          {t("remove_dependencies")}
          <div className="flex gap-2 ml-auto">
            <Button
              variant={"outline"}
              onClick={() => setRemoveDependencies("")}
            >
              {t("cancel")}
            </Button>
            <Button
              variant={"primary"}
              // isLoading={removeTaskMutation.isPending}
              // disabled={removeTaskMutation.isPending}
              onClick={handleRemoveDependencies}
            >
              {t("delete")}
            </Button>
          </div>
        </div>
      </Dialog>
      <Dialog
        isOpen={Boolean(scheduledError)}
        onClose={() => { }}
        modalClass="rounded-lg w-1/3"
      >
        <div className="flex flex-col gap-2 p-6 ">
          <img src={YallowInfoIcon} className="w-12 m-auto" />{" "}
          <div dangerouslySetInnerHTML={{ __html: t("futureTaskWarning") }} />
          <div className="flex gap-2 ml-auto">
            <Button
              variant={"primary"}
              onClick={() => {
                setScheduledError("");
              }}
            >
              {t("ok")}
            </Button>
          </div>
        </div>
      </Dialog>
      <ProjectStatusEditBlockedDialog
        isOpen={isProjectEditBlockedDialogOpen}
        onClose={() => {
          setIsProjectEditBlockedDialogOpen(false);
          setData();
        }}
        projectStatus={project?.status}
        projectSettingsLink={`/project-details/${projectId}`}
        modalClass="rounded-lg w-3/5 text-center"
      />
    </div>
  );
}
